import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import {
  BonificoOrderDTO,
  BulkInvoiceIssueResultDTO,
  CalendarDate,
  VatExemption,
} from "./BonificoOrderDTO.ts";

export function useBonificoOrderInvoicing() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const post = async <Response>(url: string, payload?: object) => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<Response>(url, payload);
      return data;
    } finally {
      setLoading(false);
    }
  };

  const setValueDate = (
    orderId: string,
    valueDate: CalendarDate,
    vatExemption?: VatExemption | null,
  ) =>
    post<BonificoOrderDTO>(`/bonifico-orders/${orderId}/value-date`, {
      valueDate,
      vatExemption,
    });

  const clearValueDate = (orderId: string) =>
    post<BonificoOrderDTO>(`/bonifico-orders/${orderId}/clear-value-date`);

  const issueInvoice = (
    orderId: string,
    finalChoices: {
      vatExemption?: VatExemption | null;
      invoiceItemDescription?: string | null;
    } = {},
  ) =>
    post<BonificoOrderDTO>(
      `/bonifico-orders/${orderId}/issue-invoice`,
      finalChoices,
    );

  const issueInvoices = (orderIds: string[]) =>
    post<BulkInvoiceIssueResultDTO>("/bonifico-orders/invoicing/issue", {
      orderIds,
    });

  return { setValueDate, clearValueDate, issueInvoice, issueInvoices, loading };
}
